import React from 'react';
import { useTranslation } from 'react-i18next';
import './AppDownloadSection.scss';

const APP_IMG = 'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/b7b5b023bcb-Photoroom.png';

const AppDownloadSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="app" aria-label={t('trangChu.app.sectionAria')} data-reveal data-anim="up">
      <div className="app__container">

        {/* Left: Phone mockup */}
        <div className="app__visual" data-reveal data-anim="left">
          <div className="app__phone-shadow" aria-hidden="true" />
          <img
            src={APP_IMG}
            alt={t('trangChu.app.imgAlt')}
            className="app__phone-img"
            loading="lazy"
          />
        </div>

        {/* Right: Content */}
        <div className="app__content" data-reveal data-anim="right">
          <span className="app__eyebrow">{t('trangChu.app.eyebrow')}</span>

          <h2 className="app__heading">
            {t('trangChu.app.heading')}<br />
            <span className="app__heading-accent">{t('trangChu.app.headingAccent')}</span>
          </h2>

          <p className="app__desc">{t('trangChu.app.desc')}</p>

          <ul className="app__features">
            <li>✓ &nbsp;{t('trangChu.app.feature1')}</li>
            <li>✓ &nbsp;{t('trangChu.app.feature2')}</li>
            <li>✓ &nbsp;{t('trangChu.app.feature3')}</li>
          </ul>

          {/* Download buttons */}
          <div className="app__buttons">
            <a
              href="https://apps.apple.com/vn/app/giao-h%C3%A0ng-th%C3%B4ng-minh/id6473515790?l=vi"
              target="_blank"
              rel="noopener noreferrer"
              className="app__btn"
              aria-label={t('trangChu.app.appStoreAria')}
            >
              <span className="app__btn-icon">
                <img src="/assets/img/apple-store.png" alt="App Store" width="28" height="28" />
              </span>
              <span className="app__btn-text">
                <span className="app__btn-sub">{t('trangChu.app.downloadOn')}</span>
                <span className="app__btn-name">App Store</span>
              </span>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.ghtm.customer&hl=vi"
              target="_blank"
              rel="noopener noreferrer"
              className="app__btn"
              aria-label={t('trangChu.app.playStoreAria')}
            >
              <span className="app__btn-icon">
                <img src="/assets/img/play-store.png" alt="Google Play" width="28" height="28" />
              </span>
              <span className="app__btn-text">
                <span className="app__btn-sub">{t('trangChu.app.downloadOn')}</span>
                <span className="app__btn-name">Google Play</span>
              </span>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AppDownloadSection;
